import AemImage from '@/components/AemImage/AemImage';
import ButtonRaw from '@/components/Buttons/ButtonRaw';
import type {ImageModel} from '@/types/aem';
import type {Badge} from '@/types/loyalty';

import BadgeImage from './BadgeImage';

type BadgeCardCompactProps = {
    badge: Badge;
    backgroundImage?: ImageModel[];
    testId?: string;
    onClick?: () => void;
};

const BadgeCardCompact = ({badge, backgroundImage, testId = 'badge-card-compact', onClick}: BadgeCardCompactProps) => {
    const {title, imageUrl, achievedImageUrl} = badge;

    return (
        <ButtonRaw
            onClick={onClick}
            data-testid={testId}
            className='w-full border-0 bg-transparent p-0 outline-none focus-visible:ring-2 focus-visible:ring-white/40'
        >
            <div className='relative h-full max-h-75 min-h-55 w-full overflow-hidden rounded-2xl bg-secondary'>
                {/* Background: natural size, centered, independent of card height */}
                <div className='absolute top-15.5 left-1/2 h-125 w-125 -translate-x-1/2 -translate-y-1/2'>
                    <AemImage imageMedia={backgroundImage} imgClassName='block' />
                </div>

                <div className='relative inset-0 z-10 mt-1 mb-2 flex w-full flex-col items-center overflow-clip'>
                    <BadgeImage imageUrl={achievedImageUrl ?? imageUrl} size={130} fetchSize={256} />
                    {title && (
                        <span className='-mt-2 line-clamp-6 w-full px-4 text-center text-16 text-romance leading-6'>
                            {title}
                        </span>
                    )}
                </div>
            </div>
        </ButtonRaw>
    );
};

export default BadgeCardCompact;
